// Badge Animation - Alternate Between Two Texts
class BadgeAnimation extends HTMLElement {
  constructor() {
    super();
    this.toggleState = false;
    this.interval = null;
  }

  connectedCallback() {
    // Find span inside the element
    this.badge = this
    if (!this.badge) return;

    this.badge1 = this.getAttribute('data-badge1') || "";
    this.badge2 = this.getAttribute('data-badge2') || "";

    // Initial text
    this.badge.textContent = this.badge1;

    // Start animation loop
    this.interval = setInterval(() => this.updateText(), 1500);
  }

  updateText() {
    const textNode = Array.from(this.badge.childNodes).find(
      n => n.nodeType === Node.TEXT_NODE && n.textContent.trim() !== ""
    );

    if (!textNode) return;

    // Fade out
    this.badge.classList.add('badge-fade-out');

    // Swap text
    setTimeout(() => {
      textNode.textContent = this.toggleState ? this.badge1 : this.badge2;
      this.badge.classList.remove('badge-fade-out');
      this.toggleState = !this.toggleState;
    }, 100); // match CSS duration
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }
}

customElements.define('badge-animation', BadgeAnimation);